import React from 'react';
import { Book, Gift, CheckCircle2 } from 'lucide-react';
export function WhatYouGetSection() {
  const tomes = [{
    num: '1',
    title: 'El Manifiesto A.C.C.I.Ó.N.',
    desc: 'Estructurá cualquier clase en 10 minutos con las 6 fases del sistema.'
  }, {
    num: '2',
    title: 'Logística de Control y Patio',
    desc: 'Manejá grupos difíciles sin gritar y sin perder la autoridad.'
  }, {
    num: '3',
    title: 'El Traductor Curricular',
    desc: 'Escribí planificaciones que aprueban inspectores sin pasar horas frente a la pantalla.'
  }, {
    num: '4',
    title: 'El Kit de Emergencia',
    desc: 'Tené clases listas para lluvia, sin materiales y días de 15 minutos.'
  }, {
    num: '5',
    title: 'El Banco de Actividades 360',
    desc: '50 actividades completas estructuradas bajo el Método A.C.C.I.Ó.N.'
  }];
  const bonuses = [{
    title: 'Guión Anti-Caos',
    desc: '27 frases exactas para recuperar el orden sin gritar.',
    value: '$8.000 ARS'
  }, {
    title: 'Planner Semanal A.C.C.I.Ó.N.',
    desc: 'Planificá toda tu semana en 15 minutos con plantillas imprimibles.',
    value: '$6.000 ARS'
  }, {
    title: 'Kit Clase Salvavidas',
    desc: '9 clases express para lluvia, sin material y días de 15 minutos.',
    value: '$9.000 ARS'
  }, {
    title: 'Mapa de Progresión 12 Semanas',
    desc: 'Tu trimestre completo ordenado con progresión pedagógica real.',
    value: '$7.000 ARS'
  }];
  return <section className="bg-gradient-to-b from-[#0F2341] to-[#0B1A2E] py-20 px-4 text-white" data-id="element-180">
      <div className="max-w-4xl mx-auto" data-id="element-181">
        <div className="text-center mb-16" data-id="element-182">
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-4" data-id="element-183">
            Todo lo que necesitás para{' '}
            <span className="text-[#F0C14B]" data-id="element-184">nunca más improvisar</span>
          </h2>
        </div>

        <div className="mb-16" data-id="element-185">
          <div className="flex items-center justify-center mb-8" data-id="element-186">
            <Book className="w-8 h-8 text-[#F0C14B] mr-3" data-id="element-187" />
            <h3 className="text-2xl md:text-3xl font-bold text-white uppercase tracking-wide" data-id="element-188">
              Los 5 Tomos del Método A.C.C.I.Ó.N.
            </h3>
          </div>

          <div className="space-y-4" data-id="element-189">
            {tomes.map((tome, idx) => <div key={idx} className="bg-white/5 border border-white/10 rounded-xl p-6 flex flex-col md:flex-row items-start md:items-center hover:bg-white/10 transition-colors" data-id="element-190">
                <div className="flex items-center mb-3 md:mb-0 md:w-1/3" data-id="element-191">
                  <span className="bg-[#D4A843] text-[#0B1A2E] w-8 h-8 rounded-full flex items-center justify-center font-bold mr-4 flex-shrink-0" data-id="element-192">
                    {tome.num}
                  </span>
                  <h4 className="text-lg md:text-xl font-bold text-white" data-id="element-193">
                    {tome.title}
                  </h4>
                </div>
                <div className="md:w-2/3 md:pl-6" data-id="element-194">
                  <p className="text-gray-300 text-lg flex items-start" data-id="element-195">
                    <CheckCircle2 className="w-5 h-5 text-green-400 mr-2 mt-1 flex-shrink-0" data-id="element-196" />
                    {tome.desc}
                  </p>
                </div>
              </div>)}
          </div>
        </div>

        <div data-id="element-197">
          <div className="flex items-center justify-center mb-8" data-id="element-198">
            <Gift className="w-8 h-8 text-[#F0C14B] mr-3" data-id="element-199" />
            <h3 className="text-2xl md:text-3xl font-bold text-white uppercase tracking-wide" data-id="element-200">
              Más los 4 Bonos Exclusivos
            </h3>
          </div>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-201">
            {bonuses.map((bonus, idx) => <div key={idx} className="bg-gradient-to-br from-[#D4A843]/10 to-transparent border border-[#D4A843]/30 rounded-xl p-6 relative overflow-hidden" data-id="element-202">
                <div className="absolute top-0 right-0 bg-[#D4A843] text-[#0B1A2E] text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-203">
                  GRATIS
                </div>
                <h4 className="text-xl font-bold text-[#F0C14B] mb-2" data-id="element-204">
                  Bono {idx + 1} — {bonus.title}
                </h4>
                <p className="text-gray-300 mb-4" data-id="element-205">{bonus.desc}</p>
                <p className="text-sm text-gray-400 line-through" data-id="element-206">
                  Valor: {bonus.value}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}